import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';
import {UmpireArticle} from '../umpire-article';
import {
  ItemSelectionType,
  UmpireComponentHeroGeneric,
} from '../umpire-component-hero-generic';

export interface UmpireComponentNews
  extends UmpireComponentHeroGeneric<UmpireComponentTypeEnum.NEWS> {
  button_text: string;
  description: string;
  external_url: string;
  has_button: boolean;
  layout: LayoutType;
  title: string;
  articles: UmpireArticle[];
  article_selections: ItemSelectionType;
}

export enum LayoutType {
  irregular = 'irregular',
  promo = 'promo',
  regular = 'regular',
  simple = 'simple',
  standard = 'standard',
}
